import React from 'react';
import { motion } from 'framer-motion';

const stappen = [
  {
    dag: 'DAG 0',
    title: 'Briefing & Vereisten',
    body: 'U dient uw personeelsaanvraag in via ons briefingformulier of rechtstreeks contact. Sector, aantal medewerkers, startdatum, vereiste certificeringen, taalvoorkeur.',
  },
  {
    dag: 'BINNEN 4U',
    title: 'Kandidaatselectie',
    body: 'Ons EU-breed talentnetwerk wordt doorzocht. Voorgeselecteerde profielen die exact aansluiten bij uw specificaties worden geïdentificeerd uit onze actieve pipeline in 12 landen.',
  },
  {
    dag: '24-48U',
    title: 'Compliance Verificatie',
    body: 'Elke kandidaat doorloopt ons complianceprotocol: RSZ-inschrijving, Dimona-voorbereiding, A1-documentreview, certificeringsvalidatie en taaltoetsing.',
  },
  {
    dag: '48-60U',
    title: 'Goedkeuring Opdrachtgever',
    body: 'Kandidaatprofielen voorgelegd ter beoordeling. Video-interview beschikbaar op dezelfde dag. U bevestigt uw selectie — BVM verzorgt alle contracten en administratie.',
  },
  {
    dag: '≤ 72U',
    title: 'Inzet op Locatie',
    body: 'Medewerker arriveert op locatie met alle documenten, gecertificeerd en klaar. BVM blijft uw enige contactpunt gedurende de volledige opdracht. SLA: 72u vanaf aanvraag.',
  },
];

const PlaatsingsProces = () => {
  return (
    <section id="proces" className="py-20 md:py-28 relative overflow-hidden" style={{ background: '#0D0D0D', borderTop: '1px solid #1A1A1A' }}>
      <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full blur-[140px] opacity-5" style={{ background: '#00E5A0' }} />
      <div className="max-w-6xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="mb-14">
          <motion.p
            className="text-xs font-body font-medium tracking-[0.2em] uppercase mb-4"
            style={{ color: '#00E5A0' }}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            PLAATSINGSPROCES
          </motion.p>
          <motion.h2
            className="text-5xl md:text-6xl lg:text-7xl font-heading font-bold leading-none mb-6"
            style={{ color: '#FFFFFF' }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            VAN AANVRAAG<br />TOT<br /><span style={{ color: '#00E5A0' }}>OP LOCATIE</span>
          </motion.h2>
          <motion.p
            className="text-base max-w-2xl leading-relaxed"
            style={{ color: '#888888' }}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            Vijf nauwkeurige stappen. Een standaardplaatsing is afgerond binnen 72 uur. Urgente aanvragen activeren ons sneltrackprotocol — gegarandeerd kandidatenlijst op dezelfde dag.
          </motion.p>
        </div>

        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-[28px] top-0 bottom-0 w-px hidden md:block" style={{ background: '#1A1A1A' }} />

          <div className="space-y-0">
            {stappen?.map((stap, i) => (
              <motion.div
                key={i}
                className="grid grid-cols-1 md:grid-cols-[80px_1fr] gap-0"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
              >
                {/* Step indicator */}
                <div className="hidden md:flex flex-col items-center pt-8">
                  <div
                    className="w-14 h-14 rounded-full flex items-center justify-center text-xs font-body font-bold flex-shrink-0 z-10"
                    style={{
                      background: i === stappen?.length - 1 ? '#00E5A0' : '#141414',
                      border: `2px solid ${i === stappen?.length - 1 ? '#00E5A0' : '#2A2A2A'}`,
                      color: i === stappen?.length - 1 ? '#0A0A0A' : '#00E5A0',
                    }}
                  >
                    {String(i + 1)?.padStart(2, '0')}
                  </div>
                </div>

                {/* Content */}
                <motion.div
                  className="p-8 ml-0 md:ml-6 mb-px"
                  style={{
                    background: '#0D0D0D',
                    border: '1px solid #1A1A1A',
                    marginBottom: i < stappen?.length - 1 ? '1px' : '0',
                  }}
                  whileHover={{ background: '#111111' }}
                >
                  <div className="flex flex-col sm:flex-row sm:items-start gap-4">
                    <div className="flex-shrink-0">
                      <span
                        className="inline-block px-3 py-1 text-xs font-body font-bold tracking-widest rounded-sm"
                        style={{ background: 'rgba(0,229,160,0.1)', color: '#00E5A0', border: '1px solid rgba(0,229,160,0.25)' }}
                      >
                        {stap?.dag}
                      </span>
                    </div>
                    <div>
                      <h3 className="text-lg font-heading font-semibold text-white mb-2">{stap?.title}</h3>
                      <p className="text-sm leading-relaxed" style={{ color: '#777777' }}>{stap?.body}</p>
                    </div>
                  </div>
                </motion.div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlaatsingsProces;
